/* eslint-disable */
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@material-ui/core/styles";
import teamStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/teamStyle.js";
import FaceDefault from "assets/img/faces/avatar.jpg";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles(teamStyle);

export default function SectionTeam() {
  const classes = useStyles();
  const [designers, setDesigners] = useState([]);

  useEffect(() => {
    fetch("https://ecommerce24.pythonanywhere.com/api/designers/")
      .then((res) => res.json())
      .then((data) => setDesigners(data));
  }, []);

  return (
    <div className={classes.team}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto, classes.textCenter)}
        >
          <h2 className={classes.title}>Tasarımcılarımız</h2>
          <h5 className={classes.description}>
            Kisetsu ürünlerini sizin için tasarlayan yaratıcı ekiple tanışın.
          </h5>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12}>
          {designers.map((designer, index) => (
            <ExpansionPanel
              key={index}
              style={{
                marginBottom: "1rem",
                borderRadius: 8,
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
            >
{/* Accordion Başlık */}
<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      textAlign: "center",
      padding: "0.5rem 0",
    }}
  >
    <img
      src={designer.photo || FaceDefault}
      alt={designer.name}
      style={{
        width: 70,
        height: 70,
        borderRadius: "50%",
        objectFit: "cover",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        marginBottom: 10,
      }}
    />
    <div style={{ fontWeight: 600, fontSize: "1.1rem", color: "#3c4858" }}>
      {designer.name}
    </div>
    {designer.position && (
      <div style={{ fontSize: "0.9rem", color: "#999" }}>{designer.position}</div>
    )}
  </div>
</ExpansionPanelSummary>


{/* Accordion İçerik – sadece uzun açıklama ve buton */}
<ExpansionPanelDetails
  style={{
    backgroundColor: "#fafafa",
    borderTop: "1px solid #eee",
    padding: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // 👈 Ortalamayı burası sağlar
  }}
>
  <p
    className={classes.cardDescription}
    style={{
      fontSize: "1rem",
      lineHeight: 1.7,
      color: "#444",
      textAlign: "center", // 👈 Yazıyı da ortalarsak daha hoş görünür
      maxWidth: 700,
    }}
  >
    {designer.description}
  </p>

  {designer.instagram && (
    <div style={{ marginTop: "1.5rem" }}>
      <Button
        href={designer.instagram}
        justIcon
        simple
        color="instagram"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-instagram" />
      </Button>
    </div>
  )}
</ExpansionPanelDetails>

            </ExpansionPanel>
          ))}
        </GridItem>
      </GridContainer>
    </div>
  );
}
